var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconAddACard = function SvgIconAddACard(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "110px",
    viewBox: "0 0 110 110",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_add_a_card")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_add_a_card",
    transform: "translate(3.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6798401,12.3157895 C44.3809708,12.3157895 61.9326668,12.3157895 85.3349282,12.3157895 C87.9113762,12.3157895 90,14.4044132 90,16.9808612 L90,54.1349282 C90,56.7113762 87.9113762,58.8 85.3349282,58.8 L18.8755981,58.8 C16.2991501,58.8 14.2105263,56.7113762 14.2105263,54.1349282 C14.2105263,48.9869373 14.2105263,45.125944 14.2105263,42.5519485",
    id: "Path",
    stroke: "current",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "current",
    fill: "none",
    strokeWidth: 3,
    cx: 75.4445344,
    cy: 44.0502024,
    r: 6.55546559
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M71.1901473,38.8103631 C70.0933788,37.9843719 68.7289708,37.4947368 67.2502024,37.4947368 C63.6297188,37.4947368 60.6947368,40.4297188 60.6947368,44.0502024 C60.6947368,47.6706861 63.6297188,50.605668 67.2502024,50.605668 C68.6309123,50.605668 69.9119257,50.1788162 70.9684783,49.4498767",
    id: "Path",
    stroke: "current",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.8631579,
    y1: 40.4,
    x2: 51.9789474,
    y2: 40.4,
    id: "Line-3",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.8631579,
    y1: 48.1473684,
    x2: 40.3578947,
    y2: 48.1473684,
    id: "Line-3-Copy",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2105263,0 L28.4210526,4.51465839 L28.4210526,13.2852863 C28.4210526,20.9456612 24.7115321,28.1245565 18.5064758,32.4919213 L18.5064758,32.4919213 L14.2105263,35.5263158 L9.91457688,32.4919213 C3.70952058,28.0886583 0,20.909763 0,13.2852863 L0,13.2852863 L0,4.51465839 L14.2105263,0 Z M14.2104518,7.10526316 C11.9014648,7.10526316 10.001357,9.00071029 10.001357,11.307246 L10.0015059,13.3145006 L8.4375,13.3145006 L8.4375,22.6480263 L19.9835526,22.6480263 L19.9835526,13.3145006 L18.4195467,13.3145006 L18.4195467,11.307246 C18.4195467,9.00223477 16.5194389,7.10526316 14.2104518,7.10526316 Z M14.2103922,15.6949178 C14.8811062,15.6949178 15.4019449,16.2148764 15.4019449,16.8844571 C15.4019449,17.2940584 15.1778919,17.6658824 14.8432649,17.8880844 L15.1793519,20.3790076 L13.2428926,20.3790076 L13.5775196,17.8880844 C13.2428926,17.6644099 13.0188396,17.2925711 13.0188396,16.8844571 C13.0188396,16.2148764 13.5396783,15.6949178 14.2103922,15.6949178 Z M14.2104146,8.8526128 C15.5881939,8.8526128 16.6692024,9.96808475 16.6692024,11.307246 L16.6692024,13.3145006 L11.7531911,13.3145006 L11.7516268,11.307246 C11.7516268,9.93179473 12.8689867,8.8526128 14.2104146,8.8526128 Z",
    id: "Combined-Shape",
    stroke: "none",
    fill: "current"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddACard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_add_a_card.5d392f10.svg";
export { ForwardRef as ReactComponent };